import { CsvOrderTemplateModelType } from '@teinor/erp/types/company/config/csvOrderTemplate'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import SearchBar from '../../../../../../baseComponents/SearchBar'
import useModulesTranslations from '../../../../../../utils/hooks/useModulesTranslations'
import { stringMatchWithSearch } from '../../../../../../utils/globals/search'
import { useCallback, useMemo, useState } from 'react'
import { BeforeSubmitHandler } from '../../../../../../forms/TwinForm/types'
import { recursiveOrderTypes } from '../../ConfigPdfTemplates/ConfigPdfTemplateSingle/ConfigPdfTemplateConfig/Tabs/CPTSectionEdit/CPTCEModal'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import { getActiveLangs } from '../../../../../../utils/reducers/getters'
import './modalCECsvOrderTemplate.sass'
interface ModalCECsvOrderTemplateProps extends ModalEditComponentProps {}

const ModalCECsvOrderTemplate: React.FC<ModalCECsvOrderTemplateProps> = ({...rest}) => {
    const {t} = useTwinTranslation()
    const langs = useMemo(() => getActiveLangs(), [])
    
    const dictTypeExportOrder = {
        0: { name: t('allM', 'Todos'), value: 0 },
        1: { name: t('justProductParents', 'Sólo productos padre'), value: 1 },
        2: { name: t('justProductChilds', 'Sólo productos hijos'), value: 1 },
    }
    const { addCSVFieldsToForm, addSelectedField, selectedFields, searchValue, setSearchValue, removeSelectedField } = useModalConfigOrderCSVFieldsLogic({...rest})
    const fields: FormRender<CsvOrderTemplateModelType> = [
        {
            cols: 3,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    required: true
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: langs,
                    required: true
                },
                {
                    name: 'typeExportOrder',
                    label: t('typeExport', 'Tipo de exportación'),
                    component: 'CustomSelectWithSearchBar',
                    required: true,
                    items: dictTypeExportOrder
                },
                {
                    name: 'is_main',
                    label: t('byDefault', 'Por defecto'),
                    component: 'Checkbox'
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ]
        }
    ]
   
    if (rest.allRowData && rest.userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, rest.userPermissions, rest.allRowData)
        return (<ModalCreateEdit fields={parsedFields} url={'/api/app/config/csvOrderTemplate/updateCsvOrderTemplate'} translations={{ title: t('editTemplate', 'Editar plantilla'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(rest.userPermissions, 'update')} {...rest} className='notFlexAutoFormRender' beforeSubmit={addCSVFieldsToForm}>
            <ConfigCsvTemplate {...{ addSelectedField, selectedFields, searchValue, setSearchValue, removeSelectedField }} />
        </ModalCreateEdit>)
    }

    return (<ModalCreateEdit fields={fields} url={'/api/app/config/csvOrderTemplate/createCsvOrderTemplate'} translations={{
        title: t('createTemplate', 'Crear plantilla'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} className='notFlexAutoFormRender' beforeSubmit={addCSVFieldsToForm}>
        <ConfigCsvTemplate {...{ addSelectedField, selectedFields, searchValue, setSearchValue, removeSelectedField }} />
    </ModalCreateEdit>)
}


interface ModalConfigOrderCSVFieldsLogicProps {
    allRowData?: RowData
}

const useModalConfigOrderCSVFieldsLogic = ({ allRowData }: ModalConfigOrderCSVFieldsLogicProps) => {
    const [selectedFields, setSelectedFields] = useState<string[]>(JSON.parse(allRowData?.code || '[]'))
    const [searchValue, setSearchValue] = useState<string>('')

    const addSelectedField = useCallback((field: string) => {
        setSelectedFields((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.push(field)
            return copyOld
        })
        setSearchValue('')
    }, [setSelectedFields, setSearchValue])

    const removeSelectedField = useCallback((pos: number) => {
        setSelectedFields((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.splice(pos, 1)
            return [...copyOld]
        })
    }, [setSelectedFields])

    const addCSVFieldsToForm: BeforeSubmitHandler = useCallback((values) => {
        values.code = JSON.stringify(selectedFields)
        return true
    }, [selectedFields])

    return { selectedFields, addSelectedField, removeSelectedField, addCSVFieldsToForm, searchValue, setSearchValue }
}


interface ConfigCsvTemplateProps {
    selectedFields: string[]
    addSelectedField: (field: string) => void
    searchValue: string
    setSearchValue: React.Dispatch<React.SetStateAction<string>>
    removeSelectedField: (pos: number) => void
}

const ConfigCsvTemplate: React.FC<ConfigCsvTemplateProps> = ({ addSelectedField, selectedFields, searchValue, setSearchValue, removeSelectedField }) => {
    const { defaultOrderTypesDict } = useModulesTranslations()
    const {t} = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    if (selectedFields.length) {
        for (const key in selectedFields) {
            const element = selectedFields[key]
            const translation = defaultOrderTypesDict[element]
            renderThis.push(<SelectedOrderCSVField translation={translation} removeSelectedField={removeSelectedField} pos={parseInt(key)} />)
        }
    }
    return (
        <div className='flex-auto flex flex-col h-1'>
            <h2>{t('configOrderCSVFields', 'Configurar Campos del csv de pedidos')}</h2>
            <div className='flex-auto flex h-1'>
                <div className='flex flex-auto'>
                    <OrderCSVFieldsVariables {...{ addSelectedField, selectedFields, searchValue, setSearchValue }} listCSVFields={recursiveOrderTypes['Products']} />
                    <div className='flex flex-col ml-20 w-full'>
                        <div className='regular18 py-10 px-20'>
                            <TwinTrans transKey='selectedFields'>Campos seleccionados</TwinTrans>:
                        </div>
                        <div className='selected_fields_container border border-gray-97 flex flex-wrap px-20 py-10 min-h-50 overflow-auto'>
                            {renderThis}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


interface OrderCSVFieldsVariablesProps {
    searchValue: string
    setSearchValue: React.Dispatch<React.SetStateAction<string>>
    selectedFields: string[]
    listCSVFields: string[]
    addSelectedField: (field: string) => void
}

const OrderCSVFieldsVariables: React.FC<OrderCSVFieldsVariablesProps> = ({ selectedFields, listCSVFields, addSelectedField, searchValue, setSearchValue }) => {
    const { t } = useTwinTranslation()
    const { defaultOrderTypesDict } = useModulesTranslations()
    const renderThis: JSX.Element[] = []
    for (const element of listCSVFields) {
        const translation = defaultOrderTypesDict[element]
        if (!selectedFields.includes(element) && stringMatchWithSearch(searchValue, translation)) {
            renderThis.push(
                <div className='order_csv_fields_row cursor-pointer hover:text-green-43' onClick={() => addSelectedField(element)}>
                    <div>{translation}</div>
                </div>
            )
        }
    }
    return (
        <div className='flex flex-col'>
            <div className='regular18 py-10 px-20'>
                <TwinTrans transKey='fieldsList'>Listado campos</TwinTrans>:
            </div>
            <div className='order_csv_fields_container w-200'>
                <SearchBar searchValue={searchValue} onChange={setSearchValue} placeholder={t('searchField', 'Buscar campo...')} className='px-20 py-10' />
                {renderThis}
            </div>
        </div>
    )
}


interface SelectedOrderCSVFieldProps {
    pos: number
    translation: string
    removeSelectedField: (pos: number) => void
}

const SelectedOrderCSVField: React.FC<SelectedOrderCSVFieldProps> = ({ pos, translation, removeSelectedField }) => {
    return (
        <div className='flex items-center m-10'>
            <span className='mr-5'>{translation}</span>
            <TwinIcon className='hover:text-red-BA cursor-pointer' icon={faTrashAlt} onClick={() => removeSelectedField(pos)} />
        </div>
    )
}

export default ModalCECsvOrderTemplate